import { updateSensorParameter } from "@/api/device/sensor";
import TnInput from "@/global/components/input/tn-input"
import TnMessage from "@/global/components/message";
import { SensorParameter } from "@/global/interface/device/sensor"

// 正整数正则匹配
const intRegex = /^[0-9]\d*$/
// float正则匹配
const floatRegex = /^[+-]?\d+(\.\d*)?$/;

interface Iprops {
    parameter: SensorParameter
    isRunning: boolean
}
export default function DeviceParamItem(props: Iprops) {

    const { parameter } = props

    const onInitValueChangeConfirm = (e: string) => {
        if (floatRegex.test(e)) {
            // 判断是否需要更新
            if (parameter?.initialValue == Number(e)) return
            updateSensorParameter(parameter.id, { initialValue: Number(e) }).then(res => {
                parameter.initialValue = Number(e)
                TnMessage.success("参数修改成功！")
            }).catch(() => {
                TnMessage.error("更新失败！")
            })
        } else {
            TnMessage.warning("输入非法！")
        }
    }

    const onIdxChangeConfirm = (e: string) => {
        if (intRegex.test(e)) {
            // 判断是否需要更新
            if (parameter?.idx == Number(e)) return
            updateSensorParameter(parameter.id, { idx: Number(e) }).then(res => {
                parameter.idx = Number(e)
                TnMessage.success("参数修改成功！")
            }).catch(() => {
                TnMessage.error("更新失败！")
            })
        } else {
            TnMessage.warning("输入非法！")
        }
    }

    return (
        <div className="list-item">
            <div className="name">
                {parameter.name}
            </div>

            {props?.isRunning ? (
                <div className="input-value">
                    {parameter?.initialValue?.toString() || ""}
                </div>
            ) : (
                <div className="input-item">
                    <TnInput
                        size="small"
                        defaultValue={parameter?.initialValue?.toString() || ""}
                        onBlur={(e) => { onInitValueChangeConfirm(e) }}
                        onPressEnter={(e) => { onInitValueChangeConfirm(e) }}
                    />
                </div>
            )}


            {props?.isRunning ? (
                <div className="input-value">
                    {parameter?.idx?.toString() || ""}
                </div>
            ) : (
                <div className="input-item">
                    <TnInput
                        size="small"
                        defaultValue={parameter?.idx?.toString() || ""}
                        onBlur={(e) => { onIdxChangeConfirm(e) }}
                        onPressEnter={(e) => { onIdxChangeConfirm(e) }}
                    />
                </div>
            )}

        </div>
    )
}